"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _myRelations = require('shared/selectors/myRelations');
var _team = require('shared/selectors/team');
var _common = require('shared/selectors/org/common');
var _user = require('shared/selectors/user');
var _templateEditing = require('shared/services/templateEditing');
var _typed = require('shared/hooks/typed');

const NO_TEAMS = []

/* The teams whose templates I manage (an admin: every team in the org;
 * anyone else: the teams they're on), whether I'm an org admin, and the
 * "Who can use it" options that follow. */
 const useTemplateScopes = (orgKey) => {
  const isAdmin = _typed.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const myTeams = _typed.useAppSelector.call(void 0, state =>
    _nullishCoalesce(_optionalChain([_myRelations.selectMyTeamGroupsList.call(void 0, state), 'access', _ => _.find, 'call', _2 => _2(g => g.orgKey === orgKey), 'optionalAccess', _3 => _3.teamsList]), () => ( NO_TEAMS)))
  const allTeams = _typed.useAppSelector.call(void 0, _team.selectTeams)
  const teams = _react.useMemo.call(void 0, 
    () => isAdmin
      ? Object.values(_nullishCoalesce(allTeams, () => ( {})))
        .filter((t) => !!t && t.OrgKey === orgKey)
        .sort((a, b) => a.Name.localeCompare(b.Name))
      : myTeams,
    [isAdmin, allTeams, myTeams, orgKey],
  )
  const orgName = _typed.useAppSelector.call(void 0, state => _optionalChain([_common.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _4 => _4.Name])) || 'your organization'
  const options = _react.useMemo.call(void 0, () => _templateEditing.templateScopeOptions.call(void 0, teams, orgName), [teams, orgName])
  return { teams, isAdmin, options, orgName }
}; exports.useTemplateScopes = useTemplateScopes
